import React from 'react'

import FormField, { FormSelectField } from '../../../components/FormField'
import Notification, { ValidationIssuesDescription } from '../../../components/Notification'
import {
    ActionButton,
    EditorFormSection,
    EditorOccupancySection,
    Field,
    InlineForm,
    InlineHeader,
    LessonEditCard,
    LessonSubject,
    SecondaryButton,
    WindowBadge,
} from '../../../components/scharedStyles/style'
import { getSubjectName } from '../../schedule/utils/lessonHelpers'
import EditScheduleOccupancy from './Occupancy'
import { useEditScheduleEditor } from './useEditScheduleEditor'

const EditScheduleEditor = ({ item, lesson, isNew = false }) => {
    const {
        form,
        isWindow,
        groupOptions,
        teacherOptions,
        subjectOptions,
        classTypeOptions,
        buildingOptions,
        buildingRoomOptions,
        bellOptions,
        isEditorAudienceLoading,
        occupancyRows,
        selectedOccupancy,
        selectedTeacherName,
        selectedGroupNames,
        selectedIds,
        groups,
        showOccupancy,
        formatScheduleDate,
        handleChange,
        handleSelectChange,
        handleBuildingChange,
        handleGroupChange,
        handleSubmit,
        tryCloseEditor,
        saveNotification,
    } = useEditScheduleEditor({ item, lesson, isNew })

    return (
        <LessonEditCard $editing $isWindow={isWindow}>
            {saveNotification && (
                <Notification
                    key={saveNotification.key}
                    title="Заполните обязательные поля"
                    description={(
                        <ValidationIssuesDescription issues={saveNotification.issues} />
                    )}
                    type="warning"
                    placement="top"
                />
            )}
            <EditorFormSection>
                <InlineHeader>
                    <LessonSubject>
                        {isNew
                            ? 'Новая запись'
                            : isWindow
                                ? 'Заполнить окно'
                                : getSubjectName(item, lesson)}
                    </LessonSubject>
                    {isWindow && <WindowBadge>Окно</WindowBadge>}
                </InlineHeader>

                <InlineForm>
                    <FormSelectField
                        label="Номер пары"
                        value={form.bell_id}
                        options={bellOptions}
                        placeholder="Номер пары"
                        onChange={(value) => handleSelectChange('bell_id', value)}
                    />

                    <FormField label="Дата">
                        <Field
                            type="date"
                            name="class_date"
                            value={form.class_date}
                            onChange={handleChange}
                        />
                    </FormField>

                    <FormSelectField
                        label="Предмет"
                        value={form.subject_id}
                        options={subjectOptions}
                        placeholder="Предмет"
                        onChange={(value) => handleSelectChange('subject_id', value)}
                    />

                    <FormSelectField
                        label="Преподаватель"
                        value={form.teacher_id}
                        options={teacherOptions}
                        placeholder="Преподаватель"
                        onChange={(value) => handleSelectChange('teacher_id', value)}
                    />

                    <FormSelectField
                        label="Тип занятия"
                        value={form.class_type_id}
                        options={classTypeOptions}
                        placeholder="Тип занятия"
                        onChange={(value) => handleSelectChange('class_type_id', value)}
                    />

                    <FormSelectField
                        label={isNew ? 'Группы' : 'Группа'}
                        multiple={isNew}
                        value={isNew ? form.group_id : form.group_id?.[0]}
                        options={groupOptions}
                        placeholder={isNew ? 'Группы' : 'Группа'}
                        onChange={(value) => handleGroupChange(value, isNew)}
                    />

                    <FormSelectField
                        label="Корпус"
                        value={form.building_id}
                        options={buildingOptions}
                        placeholder="Корпус"
                        onChange={handleBuildingChange}
                    />

                    <FormSelectField
                        label="Кабинет"
                        value={form.room_id}
                        options={buildingRoomOptions}
                        placeholder={
                            !form.building_id
                                ? 'Сначала выберите корпус'
                                : isEditorAudienceLoading
                                    ? 'Загрузка...'
                                    : 'Кабинет'
                        }
                        disabled={!form.building_id || isEditorAudienceLoading}
                        onChange={(value) => handleSelectChange('room_id', value)}
                    />

                    <ActionButton onClick={handleSubmit} type="button">
                        Сохранить
                    </ActionButton>

                    <SecondaryButton onClick={tryCloseEditor} type="button">
                        Отмена
                    </SecondaryButton>
                </InlineForm>
            </EditorFormSection>

            <EditorOccupancySection>
                <EditScheduleOccupancy
                    showOccupancy={showOccupancy}
                    form={form}
                    formatScheduleDate={formatScheduleDate}
                    selectedTeacherName={selectedTeacherName}
                    selectedGroupNames={selectedGroupNames}
                    occupancyRows={occupancyRows}
                    selectedIds={selectedIds}
                    groups={groups}
                    selectedOccupancy={selectedOccupancy}
                />
            </EditorOccupancySection>
        </LessonEditCard>
    )
}

export default EditScheduleEditor
